import axios from 'axios'
import settings from '../settings'

export default axios.create({
	baseURL: settings.neworabkapi.base_url ,
	headers: {
		'Accept': 'application/json;charset=UTF-8',
		"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
		"Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
	}
})